import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MapPin } from "lucide-react";
import api from "../../lib/api";

const LANG_LABELS = { ro: "Română", en: "English", de: "Deutsch", hu: "Magyar" };

export default function MeetingInstructionsPanel() {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [loc, setLoc] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings/meeting-instructions").then((r) => { setData(r.data); setLoc(r.data.locations[0]); }).catch(() => {});
  }, []);

  if (!data) return null;
  const setText = (l, v) => setData((d) => ({ ...d, items: { ...d.items, [loc]: { ...d.items[loc], [l]: v } } }));
  const save = async () => {
    setSaving(true);
    try {
      const r = await api.put("/settings/meeting-instructions", { items: data.items });
      setData(r.data);
      toast.success("Instrucțiuni de întâlnire salvate.");
    } catch { toast.error("Eroare la salvare."); } finally { setSaving(false); }
  };
  const filled = (l) => Object.values(data.items[l] || {}).some((t) => t && t.trim());

  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 pt-10">
      <div className="bg-white border border-bone-deep" data-testid="meeting-instructions-panel">
        <button type="button" onClick={() => setOpen((v) => !v)} data-testid="meeting-instructions-toggle" className="w-full flex items-center justify-between gap-4 p-5 text-left">
          <div className="flex items-start gap-3">
            <MapPin className="w-5 h-5 text-terracotta mt-0.5" />
            <div>
              <div className="text-[10px] uppercase tracking-wider-3 text-moss">Informații suplimentare — per locație de ridicare</div>
              <div className="font-display text-2xl text-forest mt-1">{data.locations.filter(filled).length} / {data.locations.length} locații completate</div>
              <div className="text-xs text-muted-foreground mt-1">Text general, afișat sub adresa și ora individuale din e-mailul de confirmare/actualizare, în limba clientului (fallback română). Dacă lipsește, secțiunea nu apare.</div>
            </div>
          </div>
          <span className="text-xs uppercase tracking-wider-3 text-forest shrink-0">{open ? "Ascunde" : "Editează"}</span>
        </button>
        {open && (
          <div className="border-t border-bone-deep p-5 space-y-5">
            <div className="inline-flex border border-bone-deep" data-testid="meeting-location-tabs">
              {data.locations.map((l) => (
                <button key={l} onClick={() => setLoc(l)} data-testid={`meeting-loc-${l}`} className={`px-4 py-2 text-xs uppercase tracking-wider-3 transition-colors ${loc === l ? "bg-forest text-bone" : "bg-white text-forest hover:bg-bone-deep"}`}>
                  {l}{filled(l) ? "" : " ·"}
                </button>
              ))}
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {data.langs.map((l) => (
                <label key={l} className="block">
                  <span className="text-[10px] uppercase tracking-wider-3 text-moss block mb-1">{LANG_LABELS[l]}</span>
                  <textarea rows={4} value={data.items[loc]?.[l] || ""} onChange={(e) => setText(l, e.target.value)} data-testid={`meeting-text-${l}`}
                    placeholder={l === "ro" ? "Ex.: Ne întâlnim la … cu 15 minute înainte. Ghid: … (completezi tu detaliile reale)" : "Opțional — dacă lipsește, se folosește textul în română"}
                    className="w-full border border-border px-3 py-2 text-sm outline-none focus:border-forest" />
                </label>
              ))}
            </div>
            <button disabled={saving} onClick={save} data-testid="meeting-save-btn" className="btn-lift bg-forest text-bone px-6 py-3 text-xs uppercase tracking-wider-3 disabled:opacity-60">{saving ? "Se salvează…" : "Salvează toate locațiile"}</button>
          </div>
        )}
      </div>
    </section>
  );
}
